import { ProductType } from '@inter-ikea-storageone/range';
import { SelectedMenu } from 'rangeConfig/@types';
import deleteSelectedEntity from 'rangeConfig/shared/behaviors/deleteSelectedEntity';
import replaceProduct from 'rangeConfig/shared/behaviors/replaceProduct';
import platform from 'rangeConfig/shared/utils/platform';
import DimensionsLabel from 'rangeConfig/shared/widgets/DimensionsLabel';

const widgets = {
  desktop: [
    {
      id: 'display-size',
      title: 'storageone.sizeFilterLabel',
      component: DimensionsLabel
    },
    {
      id: 'handle-selected-menu',
      cardsTitle: 'name',
      cardsSubtitle: 'typeName, designText, communicatedSizeText',
      filters: [],
      behaviors: {
        productClicked: [replaceProduct],
        productDropped: [replaceProduct]
      },
      noThumbs: () => true,
      productTypes: [ProductType.HANDLE, ProductType.EDGE_HANDLE, ProductType.KNOB],
      productFilters: []
    }
  ],
  mobile: [
    {
      id: 'frames-selected-menu-frames',
      title: '',
      cardsTitle: 'name',
      cardsSubtitle: 'typeName, designText, communicatedSizeText',
      productThumbToolTip: 'name',
      behaviors: {
        productClicked: [replaceProduct],
        productDropped: [replaceProduct]
      },
      productTypes: [ProductType.HANDLE, ProductType.EDGE_HANDLE, ProductType.KNOB],
      productFilters: []
    }
  ]
};

const selectedMenu: SelectedMenu = {
  menuTitle: 'storageone.selectedProductListChangeHandle',
  behaviors: {
    productDeleted: [deleteSelectedEntity]
  },
  content: widgets[platform]
};

export default selectedMenu;
